import { Row } from '@klickly/front-packages';
import styled from 'styled-components';

export const StyledRow = styled(Row)`
    .ant-popover-content {
        width: 350px;
    }
`;
